
import { NavLink, useParams } from "react-router";
import { useUserByIdQuery } from "../../stores/OkOkStore";
import UserEditForm from "../../components/Users/UserEditForm";
import { useTrads } from "../../contexts/trads/useTrads";
import { useAuth } from "../../contexts/auth/useAuth";
import { roles } from "../../types/Users";

import UserAdminEditForm from "../../components/Users/UserAdminEditForm";

function UserEdit(){
    const params = useParams();
    const {hasRole} = useAuth();
    const {translate}=useTrads();
    const { data, error, isLoading } = useUserByIdQuery(params.userId??"0");
    return (
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <div>
                    <nav>
                        <NavLink to={`/user/${params.userId??"0"}`}>{translate('btn_cancel')}</NavLink>
                    </nav>
                    <UserEditForm userParam={data}  />
                    {hasRole(roles.Administrators)?
                    <>
                    <hr />
                    <UserAdminEditForm userParam={data} />
                    </>
                    :null}
                    
                </div>

            ):null

    );
}
export default UserEdit;